import { render, staticRenderFns } from "./email-verification.html?vue&type=template&id=00edc8e6&"
import script from "./email-verification.js?vue&type=script&lang=js&"
export * from "./email-verification.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports